'use client';

import './PageErrorBanner.css';
import { Button, Icon, Text, Title } from '@gsk-tech/react-ui-components';

import { ERROR_BANNER } from './constants';

type ErrorBannerProps = {
  title?: string;
  description?: string;
  showButton?: boolean;
};

export const PageErrorBanner = ({
  title = ERROR_BANNER.TITLE,
  description = ERROR_BANNER.DESCRIPTION,
  showButton = true,
}: ErrorBannerProps) => {
  return (
    <div className="error-banner-container">
      <div className="error-banner-title">
        <span className="error-icon">
          <Icon name="ErrorOutline" size={60} color="red-550" />
        </span>
        <Title titleStyle="H2" color="red-550">
          {title}
        </Title>
      </div>
      <div className="error-banner-description">
        <Text textStyle="bodyPrimary" color="red-550">
          {description}{' '}
        </Text>
      </div>
      <div className="button-wrapper">
        {showButton && (
          <Button
            leadingIconName="Refresh"
            variant="outlined"
            onClick={() => window.location.reload()}
          >
            {ERROR_BANNER.BUTTON_TEXT}
          </Button>
        )}
      </div>
    </div>
  );
};
